/* bootSignal — one-shot, latching "the app behind the splash is painted"
   channel between the app React root and the splash React root (they are
   separate roots; see splashHost). Late subscribers fire immediately. */

type Off = () => void;
let fired = false;
const listeners = new Set<() => void>();

export function markAppReady(): void {
  if (fired) return;
  fired = true;
  for (const fn of [...listeners]) fn();
  listeners.clear();
}

export function onAppReady(fn: () => void): Off {
  if (fired) {
    fn();
    return () => {};
  }
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** True once markAppReady has fired (splash scheduler + tests). */
export function appReadyFired(): boolean {
  return fired;
}

/** Test-only. */
export function __resetBootSignalForTests(): void {
  fired = false;
  listeners.clear();
}
